export enum SortType{
  Neutral = 'ei ei-sort',
  Up = 'ei ei-caret-up',
  Down = 'ei ei-caret-down'
}
